/* Sui Story — predictive search overlay on the Predictive Search API
   (search/suggest.json). Debounced; image + title results plus query suggestions. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; var u = url.indexOf('//') === 0 ? 'https:' + url : url; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  ready(function () {
    var dialog = document.getElementById('SearchDialog');
    if (!dialog) return;
    var input = dialog.querySelector('[data-search-input]');
    var results = dialog.querySelector('[data-search-results]');
    var closeBtn = dialog.querySelector('[data-search-close]');
    var timer;

    if (closeBtn) closeBtn.addEventListener('click', function () { if (dialog.close) dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });

    function render(data, q) {
      var r = (data.resources && data.resources.results) || {};
      var products = r.products || [];
      var queries = r.queries || [];
      var html = '';

      if (queries.length) {
        html += '<ul class="search-suggest__queries">';
        queries.slice(0, 4).forEach(function (qq) {
          html += '<li><a href="' + root + 'search?q=' + encodeURIComponent(qq.text) + '">' + esc(qq.text) + '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<ul class="search-suggest__products">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + sized(p.featured_image.url, 120) + '" alt="" width="56" height="70" loading="lazy">' : '<span class="search-suggest__noimg"></span>';
          html += '<li><a href="' + p.url + '">' + img +
            '<span class="search-suggest__info"><span class="search-suggest__title">' + esc(p.title) + '</span>' +
            (p.product_type ? '<span class="search-suggest__meta">' + esc(p.product_type) + '</span>' : '') +
            '</span></a></li>';
        });
        html += '</ul>';
        html += '<a class="search-suggest__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">View all results →</a>';
      } else {
        html += '<p class="search-suggest__empty">No sets found for "' + esc(q) + '". Try "resham", "zari", or "neckline".</p>';
      }
      results.innerHTML = html;
    }

    function run(q) {
      if (!q || q.length < 2) { results.innerHTML = ''; return; }
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url).then(function (res) { return res.json(); }).then(function (data) { render(data, q); }).catch(function () {});
    }

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { run(q); }, 220);
      });
    }
  });
})();
